//#region imports
import React, { useEffect, useState } from 'react'

// tremor
import { Subtitle } from "@tremor/react";

//redux
import { useSelector } from "react-redux";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// styling
import "./actions-modal.css"
import { Spacing, Colors } from "_styles";

// boostrap
import { Modal, Row, Col, Button } from 'react-bootstrap';

// icons
import { IoClose } from "react-icons/io5";

// components
import { CustomDivider } from "_atoms";

//#endregion

const ActionsModal = ({ title = "Modal", subtitle, headerIcon, show, handleClose, children, isTimeline, minWidth, maxWidth, minHeight, maxHeight }) => {

    // redux 
    const usedTheme = useSelector(selectUsedTheme);

    // local 
    const [modalBgColor, setModalBgColor] = useState('white');
    const [modalTextColor, setModalTextColor] = useState('black');


    useEffect(() => {
        if (isTimeline == true) {
            setModalBgColor(usedTheme.BACKGROUND_COLOR);
            setModalTextColor(usedTheme.TEXT_COLOR);
        }
        else {
            setModalBgColor('white');
            setModalTextColor('black')
        }
    }, [isTimeline, usedTheme]);

    return (

        <>
            {/* <style>
                {console.log(modalBgColor, "modalBgColormodalBgColormodalBgColor")}
                {`
                .custom-modal-dialog .modal-content {
                    background-color: ${modalBgColor}!important;
                    color: ${modalTextColor};
                    border-radius: 15px;
                    border: none;
                }
            `}
            </style> */}

            <Modal
                show={show}
                centered
                className="custom-modal"
                dialogClassName="custom-modal-dialog"
                style={{
                    '--min-width': '1100px',
                    '--max-width': '1100px',
                    '--min-height': '300px',
                    '--max-height': '300px',
                    '--top-margin': '2.5vh',
                    "--modalBgColor": modalBgColor,
                    "--modalTextColor": modalTextColor
                    // borderRadius: 15,
                }}>

                {/* header */}
                <div style={{ marginLeft: Spacing.SCALE_28, marginRight: Spacing.SCALE_28, marginTop: Spacing.SCALE_28, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    {/* icon + title + subtitle + close button*/}
                    <div style={{ flex: 1 }}>

                        {/* icon */}
                        {headerIcon && headerIcon}

                        {/* title + close modal button */}
                        <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', flex: 1 }}>

                                {/* title */}
                                <p style={{ fontSize: 34, fontWeight: 'bold', color: isTimeline ? usedTheme.TEXT_COLOR : 'black', margin: 0 }}>{title}</p>

                                {/* close modal button */}
                                <Button variant={isTimeline ? usedTheme.BUTTON_VARIANT : 'light'} onClick={handleClose}>
                                    <IoClose
                                        size={32}
                                        color={'grey'}
                                    />
                                </Button>

                            </div>

                            {/* subtitle */}
                            <div style={{ display: 'flex', flex: 1 }}>

                                {/* subtitle */}
                                <div style={{ flex: 4 }}>
                                    <Subtitle>{subtitle ? subtitle : ""}</Subtitle>
                                </div>

                                {/* spacer */}
                                <div style={{ flex: 1 }} />
                            </div>

                        </div>
                    </div>

                </div>

                {/* horizontal line */}
                <div>
                    <CustomDivider />
                </div>

                {/* body */}
                <div style={{ padding: Spacing.SCALE_32, overflowY: 'auto' }}>
                    {children}
                </div>

            </Modal>

        </>
    )
}

export default ActionsModal
